type ButtonTheme =
  | "black"
  | "outline-black"
  | "text-black"
  | "primary"
  | "outline-primary"
  | "text-primary"
  | "secondary"
  | "outline-secondary"
  | "text-secondary"
  | "success"
  | "outline-success"
  | "text-success"
  | "warning"
  | "outline-warning"
  | "text-warning"
  | "danger"
  | "outline-danger"
  | "text-danger";

type ButtonSize = "large" | "medium" | "outline-medium" | "small" | "outline-small";

const themeClasses: Record<ButtonTheme, string> = {
  black: "text-white bg-gray-900 hover:bg-black disabled:cursor-not-allowed disabled:opacity-75",
  "outline-black": "bg-transparent ring-2 ring-gray-900 hover:ring-black text-gray-500 hover:text-gray-600 shadow-sm",
  "text-black": "text-gray-900 hover:text-black",
  primary: "text-white bg-brand-blue-400 hover:bg-brand-blue-500 disabled:cursor-not-allowed disabled:opacity-75",
  "outline-primary": "bg-transparent ring-2 ring-brand-blue-400 hover:ring-brand-blue-500 text-gray-500 hover:text-gray-600 shadow-sm",
  "text-primary": "text-brand-blue-400 hover:text-brand-blue-600",
  secondary: "text-white disabled:cursor-not-allowed disabled:opacity-75 bg-gray-500 hover:bg-gray-600",
  "outline-secondary": "bg-transparent ring-2 ring-gray-500 hover:ring-gray-600 text-gray-500 hover:text-gray-600 shadow-sm",
  "text-secondary": "text-gray-500 hover:text-gray-600",
  success: "text-white disabled:cursor-not-allowed disabled:opacity-75 bg-green-500 hover:bg-green-600",
  "outline-success": "bg-transparent ring-2 ring-green-500 hover:ring-green-600 text-gray-500 hover:text-gray-600 shadow-sm",
  "text-success": "text-green-500 hover:text-green-600",
  warning: "text-white bg-orange-400 hover:bg-orange-500 disabled:cursor-not-allowed disabled:opacity-75",
  "outline-warning": "bg-transparent ring-2 ring-orange-400 hover:ring-orange-500 text-gray-500 hover:text-gray-600 shadow-sm",
  "text-warning": "text-orange-500 hover:text-orange-600",
  danger: "text-white bg-red-500 hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-75",
  "outline-danger": "bg-transparent ring-2 ring-red-500 hover:ring-red-600 text-gray-500 hover:text-gray-600 shadow-sm",
  "text-danger": "text-red-500 hover:text-red-600",
};

const sizeClasses: Record<ButtonSize, string> = {
  large: "px-16 py-3.5 font-medium text-center",
  medium: "px-12 py-2.5 font-medium text-center",
  "outline-medium": "px-12 py-2 font-medium text-center",
  small: "px-4 py-1.5 font-medium text-center",
  "outline-small": "px-4 py-1 font-medium text-center",
};

export const Button = ({
  id = undefined,
  label,
  theme = undefined,
  size = undefined,
  className = undefined,
  onClick = undefined,
  disabled = false,
}: {
  id?: string;
  label: string;
  theme?: ButtonTheme;
  size?: ButtonSize;
  className?: string;
  onClick?: () => void | Promise<void>;
  disabled?: boolean;
}) => {
  const baseClasses = "rounded-md";
  const themedClass = theme ? themeClasses[theme] : "";
  const sizedClass = size ? sizeClasses[size] : "";
  const finalClassName = [baseClasses, themedClass, sizedClass, className]
    .filter(Boolean)
    .join(" ");

  return (
    <button id={id} className={finalClassName} onClick={onClick} disabled={disabled}>
      {label}
    </button>
  );
};
